'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {wpModel} from "../../models/wpmodel.js";
import {annexModel} from "../../models/annexmodel.js";

export class SectionBAnnexesCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'b_annexes_before',
			on: false,
			value: null
		},
		after: {
			key: 'b_annexes_after',
			on: false,
			value: null
		}
	};

	annexes = [];
	cfg = {
		maxFileSize: 0,
		fileFilter: {},
		detailedBudgetTableFilter: {}
	};
	dragClass = '';
	annexUploadUrl;
	notify;

	constructor($scope, $filter, jsDataService, notify, $mdDialog){
		super($scope, $filter, jsDataService);
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		if(typeof(this.section.annexes) !== 'undefined'){
			this.initAnnexes(this.section.annexes);
		}
		this.cfg.fileFilter = this.jsDataService.get('cfgFileFilter', {});
		this.cfg.maxFileSize = this.jsDataService.get('maxFileSize', 0);
		this.cfg.detailedBudgetTableFilter = this.jsDataService.get('detailedBudgetTableFilter', {});
		this.annexUploadUrl = this.jsDataService.get('cfgUploadUrl');
	}

	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}

	initAnnexes(annexes){

		for(let annex of annexes){
			this.annexes.push(new annexModel(annex, this.$filter, this.jsDataService));
		}
	}

	fileUploaded($file, $message, annex, $flow){
		if($file.response.success){
			annex.file.file_id = $file.response.fileId;
			annex.file.done = true;
			this.saveAnnex(annex);
		}
	}

	saveAnnex(annex){
		let data = {
			ord : annex.ord,
			b_annexes_type : annex.id,
			file_id: annex.file.file_id,
			file_name: annex.file.file_name
		};
		if(this.jsDataService.get('cfgAnnexSaveUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgAnnexSaveUrl'),
				method: 'POST',
				data: data
			}).then((response) => {
				if(response.data.success && typeof(response.data.item) !== 'undefined'){
					if(annex.id > 0){
						annex = angular.extend(annex, response.data.item);
					}
				}
			}, () => {});
		}
		else{
			console.log('no url ', this.jsDataService.get('cfgAnnexSaveUrl'));
		}
	}

	fileSubmited(annex, $files){
		annex.flow.upload();
	}

	filesAdded($files){
		return true;
	}

	fileAdded($file, annex){
		const ext = $file.getExtension();
		if(annex.is_xlsx == 1) { //Detailed Budget Table
			if(typeof(this.cfg.detailedBudgetTableFilter[ext]) === 'undefined' || !this.cfg.detailedBudgetTableFilter[ext]){
//				console.log("Extension '" + ext + "' not allowed");
				this.notify(this.$filter('tr')('detailed_budget_table_wrong_format'), true);
				return false;
			}
		}
		else if(typeof(this.cfg.fileFilter[ext]) === 'undefined' || !this.cfg.fileFilter[ext]){
//			console.log("Extension '" + ext + "' not allowed");
			this.notify(this.$filter('tr')('file_wrong_format'), true);
			return false;
		}
		if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
			this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
			return false;
		}
		if(!this.activeUpload()){
			return false;
		}
		this.addFlowFile($file, annex);
		return true;
	}


	activeUpload(){
		return true;
	}

	classOnDrag(value){
		if(this.activeUpload()){
			this.dragClass = value;
		}
	}

	classOffDrag(value){
		this.dragClass = value;
	}

	addFlowFile($file, annex){
		let file = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		annex.file = file;
	}

	editAnnex(ev, annex){
		this.annexEditor(ev, annex);
	}

	annexEditor(ev, annex){

		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "annex", "fieldCfg", this.annexEditorDialogCtrl],
			templateUrl: 'application/annex_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				annex: annex,
				fieldCfg: this.fieldCfg
			}
		}).then((tocItem) => {
			if(this.jsDataService.get('cfgAnnexSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgAnnexSaveUrl'),
					method: 'POST',
					data: tocItem
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						if(annex.id > 0){
							annex = angular.extend(annex, response.data.item);
						}
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgAnnexSaveUrl'));
			}
		}, () => {});
	}

	removeAnnex(ev, annex){
		if(this.jsDataService.get('cfgAnnexRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('annexRemoveConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgAnnexRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: annex.annex.id
					}
				}).then((results) => {
					if(results.data.success){
						annex.is_application = 0;
						annex.annex = {};
						delete annex.file;
					}
				});
			}, () => {});
		}
	}

	annexEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, annex, fieldCfg){
		$scope.annex = angular.copy(annex);

		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};
		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};
		$scope.isValid = function(){
			return (!$scope.fieldRequire('b_annexes_title') || $scope.annex.annex.b_annexes_title !== '');
		};
		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.annex.annex);
		};
	}
}

